var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-card',{attrs:{"title":_vm.$t('dashboard.continueToEdit'),"data":_vm.data,"color":"#ff9f43"}},[[_c('edit-icon',{staticClass:"custom-class",staticStyle:{"stroke":"#ff9f43"},attrs:{"size":"1.5x"}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }